import { Link, useLocation } from "react-router-dom";
import { useMemo } from "react";
import cn from "@/utils/class-names";
import useMobile from "@/hooks/use-mobile";
import { useDrawer } from "@/app/shared/drawer-views/use-drawer";
import { routes } from "@/config/routes";

import useProfile from "@/hooks/use-profile";
import { Roles } from "@/utilities/types/Users";
import { zIndex } from "@/utilities/constants/zIndex";
import { MdOutlineContactPhone } from "react-icons/md";
import { IoAnalytics } from "react-icons/io5";
import { PiCurrencyCircleDollarLight } from "react-icons/pi";

export function BottomNavBar() {
  const location = useLocation();
  const isMobile = useMobile();
  const { isOpen: isDrawerOpen } = useDrawer();
  const { profile } = useProfile();

  const navItems = useMemo(
    () =>
      [
        {
          id: "leads",
          name: "Leads",
          href: routes.contacts.listing,
          icon: MdOutlineContactPhone,
        },
        {
          id: "ad-report",
          name: "Ad Report",
          href: routes.adReport,
          icon: IoAnalytics,
          requiresAdReport: true,
        },
        {
          id: "ad-credits",
          name: "Ad Credits",
          href: routes.adCredit.dashboard,
          icon: PiCurrencyCircleDollarLight,
        },
      ].filter((item) => {
        if (item.requiresAdReport && !profile?.adRerportUrl) return false;
        return true;
      }),
    [profile?.adRerportUrl],
  );

  // Don't show if not mobile, if drawer is open, or if not AGENCY role
  if (!isMobile || isDrawerOpen || profile?.role !== Roles.AGENCY) {
    return null;
  }

  return (
    <div
      className="fixed md:hidden bottom-2 w-full flex items-center justify-center"
      style={{
        zIndex: zIndex.bottomNavBar,
      }}
    >
      <nav className="bg-white border border-gray-100 px-7 py-3 flex justify-between items-center shadow-xl rounded-[40px] gap-6">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive =
            location.pathname === item.href ||
            location.pathname.startsWith(item.href + "/");

          return (
            <Link
              key={item.id}
              to={item.href}
              className={cn(
                "flex flex-col items-center transition-colors",
                isActive ? "text-black" : "text-gray-400",
              )}
            >
              <Icon className="h-6 w-6" />
              <span className="text-[10px] font-bold">{item.name}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
